export const isValidPostalCode = (postalCode: string = ""): boolean => {
  return /^\d{5}$/.test(postalCode);
};